module.exports = {
      id: "phone-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#phone",
      toString: function () {
        return this.url;
      }
    }